import React, { useEffect, useState } from "react";
import { DropArrow, SearchIcon, SearchIconWhite } from "../../../assets/images";
import { MultiSelect } from "react-multi-select-component";
import {
  addReport,
  getReportsDataset,
  getReportsDatasetColumns,
  getReportsDatasetByReportID,
  getUsers,
  getReportsDatasetColumnsById,
  getReportList,
  getAssignedUserList,
  updateReport,
} from "../../../services/configurationServices";
import { SuccessToast } from "../../../CustomHooks/SuccessToast";
import { ErrorToast } from "../../../CustomHooks/ErrorToast";


export const ReportTemplateForm = ({ isDarkTheme, 
  isReportFormEnabled, reportSaveBtnClicked, setReportSaveBtnClicked,
  setIsEmptyReportForm, setIsReportFormEnabled,
  setAddNewClicked, addNewClicked }) => {
   
  const [datasets, setDatasets] = useState([]); // State to store datasets
  const [selectedDatasetDetails, setSelectedDatasetDetails] = useState([]); // State to store details of the selected dataset
  const [selectedColumns, setSelectedColumns] = useState([]); // State to store selected columns
  const [userList, setUserList] = useState([]); // State to store user list
  const [selectedUsers, setSelectedUsers] = useState([]); // State to store selected users
  const [reportName, setReportName] = useState("");
  const [reportNameError, setReportNameError] = useState(""); // State to manage report name error
  const [reportDescription, setReportDescription] = useState("");
  const [reportDescriptionError, setReportDescriptionError] = useState("");
  const [selectedDatasetError, setSelectedDatasetError] = useState(""); // State to manage dataset error
  const [selectedColumnsError, setSelectedColumnsError] = useState(""); // State to manage selected columns error
  const [selectedUsersError, setSelectedUsersError] = useState(""); // State to manage selected users error
  const [currentDatasetId, setCurrentDatasetId] = useState(0); // State to manage selected dataset ID
  const [reportList, setReportList] = useState([]); // State to manage report list
  const [searchReport, setSearchReport] = useState(""); // State to manage search input
  const [filteredItems, setFilteredItems] = useState(reportList); // State to manage filtered items
  const [selectedReport, setSelectedReport] = useState(''); // State to manage form enabled state


  //Initial load
  useEffect(() => {
    const fetchDatasets = async () => {
      try {
        const response = await getReportsDataset(); // Call the API
        //const userlist = await getUsers();
        const userlist = await getAssignedUserList({}); // Fetch the user list
        //const reportListResponse = await getReportList();
        getAllReports(); // Fetch all reports
        //setReportList(reportListResponse?.Data); // Store the report list in state
        //setFilteredItems(reportListResponse?.Data); // Store the filtered items in state
        setDatasets(response?.Data); // Store the response in state
        if(userlist?.Data) {
          setUserList(userlist?.Data);
        }
        
      } catch (err) {
        console.error("Error fetching datasets:", err);
      }
    };

    fetchDatasets(); // Call the function on mount
  }, []); // Empty dependency array ensures this runs only once on mount

  const validateReportForm = () => {
    // Validate report name and description
    let isValid = true; // Initialize a variable to track form validity
    if (!reportName) {
      setReportNameError("Please enter report name"); // Set error message if report name is empty
      isValid = false; // Set validity to false
    } else {
      setReportNameError(""); // Reset error state if report name is valid
    }
    if (!reportDescription) {
      setReportDescriptionError("Please enter report description"); // Set error message if report description is empty
      isValid = false; // Set validity to false
    } else {
      setReportDescriptionError(""); // Reset error state if report description is valid
    }
    if (!currentDatasetId) {
      setSelectedDatasetError("Please select a dataset"); // Set error message if no dataset is selected
      isValid = false; // Set validity to false
    } else {
      setSelectedDatasetError(""); // Reset error state if a dataset is selected
    }
    if (selectedColumns.length === 1) {
      setSelectedColumnsError("Please select at least one column"); // Set error message if no columns are selected
      isValid = false; // Set validity to false
    }
    else {
      setSelectedColumnsError(""); // Reset error state if columns are selected
    }
    // if (selectedUsers.length === 0) {
    //   setSelectedUsersError("Please select at least one user"); // Set error message if no users are selected
    //   isValid = false; // Set validity to false
    // }
    // else {
    //   setSelectedUsersError(""); // Reset error state if users are selected
    // }

    return isValid; // Return true if all validations pass
    // Check if there are any errors
  }

  const resetState = () => {
    setReportName(""); // Reset report name state
    setReportDescription(""); // Reset report description state
    setSelectedColumns([]); // Reset selected columns state
    setSelectedUsers([]); // Reset selected users state
    setCurrentDatasetId(0); // Reset dataset ID state
    setSelectedDatasetDetails([]); // Reset dataset details state
    setSelectedDatasetError(""); // Reset dataset error state
    setSelectedColumnsError(""); // Reset selected columns error state
    setSelectedUsersError(""); // Reset selected users error state
    setReportNameError(""); // Reset report name error state
    setSearchReport(""); // Reset search input state
  }

  const getAllReports = async () => {
    try {
      const response = await getReportList(); // Call the API
      setReportList(response?.Data); // Store the report list in state
      setFilteredItems(response?.Data); // Store the filtered items in state
    } catch (err) {
      console.error("Error fetching datasets:", err);
    }
  }

  const addNewReport = () => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const { OrganizationMasterID } = user;

        const payload = {
          "UserID": user?.Id,
          "ReportName": reportName?.toString().trim(),
          "ReportDescription": reportDescription?.toString().trim(),
          "IsActive": 1,
          "OrganizationMasterID": OrganizationMasterID,
          "ReportDataSetID": currentDatasetId,
          "SelectedColumns": selectedColumns,
          "AccessList": selectedUsers,
        }
        addReport(payload).then((response) => {
          if (response?.Status === "success") {
            getAllReports(); // Fetch all reports after adding a new report
            resetState(); // Reset the form state after successful submission
            setReportSaveBtnClicked(false); // Reset the button clicked state
            SuccessToast(response?.Message); // Show success toast message
          } else {
            setReportSaveBtnClicked(false); // Reset the button clicked state
            ErrorToast("Unable to add Report"); // Show error toast message
          }
        }).catch((err) => {
          console.error("Error adding report:", err); // Log any errors
          setReportSaveBtnClicked(false); // Reset the button clicked state
          ErrorToast("Unable to add Report"); // Show error toast message
        });
      } catch (err) {
        console.error("Error saving report:", err); // Log any errors
      }
  }

  const updateCurrentReport = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const { OrganizationMasterID } = user;

      const payload = {
        "UserID": user?.Id,
        "ReportName": reportName,
        "ReportDescription": reportDescription,
        "IsActive": 1,
        "OrganizationMasterID": OrganizationMasterID,
        "ReportDataSetID": currentDatasetId,
        "SelectedColumns": selectedColumns,
        "AccessList": selectedUsers,
        "ReportID": selectedReport["Report ID"]
      }
      updateReport(payload).then((response) => {
        if (response?.Status === "success") {
          getAllReports(); // Fetch all reports after updating the report
          resetState(); // Reset the form state after successful submission
          setSelectedReport(''); // Reset selected report state
          setReportSaveBtnClicked(false); // Reset the button clicked state
          setIsReportFormEnabled(false)
          SuccessToast(response?.Message); // Show success toast message
        } else {
          setReportSaveBtnClicked(false); // Reset the button clicked state
          ErrorToast("Unable to Update Report"); // Show error toast message
        }
      }).catch((err) => {
        console.error("Error adding report:", err); // Log any errors
        setReportSaveBtnClicked(false); // Reset the button clicked state
        ErrorToast("Unable to Update Report"); // Show error toast message
      });
    } catch (err) {
      console.error("Error saving report:", err); // Log any errors
    }
  }
  const deleteReport = () => {}

  useEffect(() => {
    if (reportSaveBtnClicked) {
      if (!validateReportForm()) {
        setReportSaveBtnClicked(false); // Reset the button clicked state
        return; // Exit the function if validation fails
      }

      if(selectedReport === ''){
        addNewReport(); // Call the addReport function
      }
      else{
        updateCurrentReport(); // Call the updateReport function
      }

    }
    setReportSaveBtnClicked(false); // Reset the button clicked state after validation
  }, [reportSaveBtnClicked]); // Run this effect when reportSaveBtnClicked changes


  const handleDatasetChange = async (event) => {
    //const selectedDatasetId = ; // Get the selected ReportDataSetID
    const selectedDatasetId = parseInt(event.target.value); // Parse the selected ID as an integer
    setCurrentDatasetId(parseInt(event.target.value)); // Update the selected dataset ID in state
    // If the selected ID is 0, reset states and exit
    if (selectedDatasetId === 0) {
      setSelectedDatasetDetails([]); // Reset dataset details
      setSelectedColumns([]); // Reset selected columns
      setSelectedDatasetError("Please select a dataset"); // Set error message
      return; // Exit the function
    }

    setSelectedDatasetError(""); // Reset error state if a dataset is selected
    try {
      const response = await getReportsDatasetColumns(selectedDatasetId); // Call the new API with the selected ID
      const datasetDetails = response?.Data || [];
      setSelectedDatasetDetails(datasetDetails); // Store the response in state
      // If OffsetMinutes column exists in dataset, include it by default in selectedColumns
      const offsetCol = datasetDetails.find((c) => c.DisplayColumnName === "OffsetMinutes");
      if (offsetCol) {
        setSelectedColumns([offsetCol.ReportDataSetColumnID]);
      } else {
        setSelectedColumns([]); // Reset selected columns when a new dataset is selected
      }
      setSelectedDatasetError(""); // Reset error state if a dataset is selected
    } catch (err) {
      console.error("Error fetching dataset details:", err);
    }
  };

  const handleColumnChange = (selectedOptions) => {
    const cols = selectedOptions.map((option) => option.value); // Get the selected column values
    
    // Always include OffsetMinutes if it exists in the dataset
    const offsetCol = selectedDatasetDetails.find((c) => c.DisplayColumnName === "OffsetMinutes");
    if (offsetCol && !cols.includes(offsetCol.ReportDataSetColumnID)) {
      cols.push(offsetCol.ReportDataSetColumnID);
    }
    
    setSelectedColumns(cols);
    if (cols.length > 1) {
      setSelectedColumnsError(""); // Clear error if columns are selected
    }
  };

  const handleUserChange = (selectedOptions) => {
    const users = selectedOptions.map((option) => option.value); // Get the selected user values
    setSelectedUsers(users); // Update selected users based on MultiSelect options
    // if(users.length !== 0) {
    //   setSelectedUsersError(""); // Set error message if no users are selected
    // } // Update selected users based on MultiSelect options
  };

  const clearSelectedReport = () => {
    setSelectedReport(''); // Reset selected report state
    setReportName(""); // Reset report name state
    setReportDescription(""); // Reset report description state
    setSelectedColumns([]); // Reset selected columns state
    setSelectedUsers([]); // Reset selected users state
    setCurrentDatasetId(0); // Reset dataset ID state
    setSelectedDatasetDetails([]); // Reset dataset details state
    setSelectedDatasetError(""); // Reset dataset error state
    setSelectedColumnsError(""); // Reset selected columns error state
    setSelectedUsersError(""); // Reset selected users error state
    setReportNameError(""); // Reset report name error state
    setIsEmptyReportForm(true); // Set empty report form state to true
    setIsReportFormEnabled(true); // Enable the report form
    setAddNewClicked(false);
  }

  const clearReportErrorFields = () => {
    setReportNameError(""); // Reset report name error state
    setReportDescriptionError(""); // Reset report description error state
    setSelectedDatasetError(""); // Reset dataset error state
    setSelectedColumnsError(""); // Reset selected columns error state
    setSelectedUsersError(""); // Reset selected users error state
  }

  useEffect(() => {
      if (addNewClicked) {
        //Empty all the fields(
        clearSelectedReport();
      }
    }, [addNewClicked]);

  // Generate MultiSelect options dynamically from selectedDatasetDetails
  // Filter out the OffsetMinutes column so it is not selectable
  let multiSelectOptions = selectedDatasetDetails
    ?.filter((column) => column.DisplayColumnName !== "OffsetMinutes")
    .map((column) => ({
      label: column.DisplayColumnName,
      value: column.ReportDataSetColumnID,
    }));

  console.log({selectedDatasetDetails, multiSelectOptions})

  // Generate user list options dynamically from userList
  const userListOptions = userList?.map((user) => ({
    label: user.UserName,
    value: user.Id
  }));

  useEffect(() => {
    const filteredItems = reportList.filter((item) => {
      return item["Report Name"]
        .toLowerCase()
        .includes(searchReport.toLowerCase()); // Filter items based on search input
    });
    setFilteredItems(filteredItems); // Update filtered items state
  }, [searchReport]); // Run this effect when searchReport changes

  const fetchDatasetsToEdit = async () => {
      // try {
      //   const response = await getReportsDatasetByReportID({'ReportID':selectedReport["Report ID"]}); // Call the API
      //   const data = response?.Data[0]; // Get the first dataset from the response
      //   setCurrentDatasetId(data?.ReportDataSetID); // Store the response in state
      // } catch (err) {
      //   console.error("Error fetching datasets:", err);
      // }

      getReportsDatasetByReportID({
        ReportID: selectedReport["Report ID"],
      }).then((response) => {
        const data = response?.Data[0]; // Get the first dataset from the response
        setCurrentDatasetId(data?.ReportDataSetID); // Store the response in state
        getReportsDatasetColumnsById(
          data?.ReportDataSetID,
          selectedReport["Report ID"]
        ).then((response) => {
          const datasetDetails = response?.Data || []; // Get the dataset details from the response
          setSelectedDatasetDetails(datasetDetails); // Store the dataset details in state
            let columns = datasetDetails
            .filter((column) => column.UseFlag == 1)
            .map((column) => column.ReportDataSetColumnID); // Get only the column IDs with UseFlag == 1
          // If OffsetMinutes exists in the dataset, ensure it's included by default
          const offsetCol = datasetDetails.find((c) => c.DisplayColumnName === "OffsetMinutes");
          if (offsetCol && !columns.includes(offsetCol.ReportDataSetColumnID)) {
            columns = [...columns, offsetCol.ReportDataSetColumnID];
          }
          setSelectedColumns(columns); // Set the selected columns state
        });
      });

      getAssignedUserList({ ReportID: selectedReport["Report ID"] }).then(
        (response) => {
          const data = response?.Data || []; // Get the assigned user list from the response
          const users = data
            .filter((user) => user.UseFlag == 1)
            .map((user) => user.Id);
            setSelectedUsers(Array.from(new Set(users))); // Set the selected users state with unique values
        }
      );
    };

  useEffect(() => {
    if(selectedReport!==''){
      fetchDatasetsToEdit()
    }
      
  },[selectedReport])

  useEffect(() => {
    if (!isReportFormEnabled && selectedReport === '') {
      clearSelectedReport();
    }
    if (!isReportFormEnabled && selectedReport !== '') {
      setReportName(selectedReport["Report Name"]); // Set report name state
      setReportDescription(selectedReport["Report Description"]); // Set report description state
      setCurrentDatasetId(selectedReport["ReportDataSetID"]); // Set dataset ID state
      fetchDatasetsToEdit(); // Fetch datasets to edit
      clearReportErrorFields();
    }
  }, [isReportFormEnabled]);
  

  return (
    <div className="col-lg-12 mt-2">
      <div className="SiteMainContainer UserHgtContainer">
        <div className="SiteMainHeightDiv">
          <div className="SiteLeftContainer AutoHgtSiteScrollbar">
            <div className="m-2 HeaderSiteList">
              <input
                id="Search_txt"
                className="SearchViewInput1"
                type="text"
                placeholder="Search"
                value={searchReport}
                onChange={(e) => {
                  setSearchReport(e.target.value); // Update search input state
                }} // Update search input state
              />
              <div className="SearchTextDivConfigTool">
                {isDarkTheme ? (
                  <img className="EyeIcon" src={SearchIcon} alt="search icon" />
                ) : (
                  <img
                    className="EyeIcon"
                    height="15"
                    alt="search icon"
                    src={SearchIconWhite}
                  />
                )}
              </div>
            </div>
            <div className="NotificationList" style={{ height: "auto" }}>
              {reportList &&
                (filteredItems?.length > 0 ? (
                  filteredItems.map((report, index) => (
                    <div 
                      key={index} 
                      className={`OneList ${
                        selectedReport["Report ID"] === report["Report ID"] ? "SelectedList" : ""
                      }`} // Add 'SelectedList' if the current report is selected
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent event bubbling
                        setReportName(report["Report Name"]); // Set report name state
                        setReportDescription(report["Report Description"]); // Set report description state
                        setSelectedReport(report); // Enable edit mode
                        setIsEmptyReportForm(false); // Set empty report form state to false
                        setIsReportFormEnabled(false)
                      }}>
                      <p className="ListofText">{report["Report Name"]}</p>
                    </div>
                  ))
                ) : (
                  <div className="no-data-found">
                    <p>No Reports Found</p>
                  </div>
                ))}
              {!reportList && (
                <div className="no-data-found">No Reports Available</div>
              )}
            </div>
            {/* <div className="NotificationList" style={{ height: "auto" }}>
              <div className="NotificationList" style={{ height: "auto" }}>
                {reportList.map((report, index) => (
                  <div key={index} className="OneList">
                    <p className="ListofText">{report["Report Name"]}</p>
                  </div>
                ))}
              </div>
            </div> */}
          </div>

          <div className="SiteRightContainer UserMainFormDiv">
            <div className="userformContainer">
              <form style={{ height: "100%" }}>
                <div className="Notification-form reportTemplateForm">
                  <div className="inputMainContainer w40dot75rem mt30">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Report Name*</label>
                      <input
                        className="inputType"
                        placeholder="Enter report name here"
                        disabled={!isReportFormEnabled}
                        value={reportName}
                        onChange={(e) => {
                          setReportName(e.target.value);
                          setReportNameError(""); // Reset error state on change}
                        }} // Update report name state
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {reportNameError} </span>
                      </p>
                    </div>
                  </div>

                  <div
                    className="inputMainContainer w40dot75rem mt20"
                    style={{ height: "auto" }}
                  >
                    <div
                      className="inputTypeLabelContainer"
                      style={{ height: "auto" }}
                    >
                      <label className="formFieldLabels">Description*</label>
                      <textarea
                        className="inputType"
                        type="textarea"
                        rows={3}
                        placeholder="Enter description"
                        disabled={!isReportFormEnabled}
                        value={reportDescription}
                        onChange={(e) => {
                          setReportDescription(e.target.value);
                          setReportDescriptionError(""); // Reset error state on change
                        }} // Update report description state
                        style={{ height: "auto",
                          cursor: !isReportFormEnabled ? "not-allowed" : "", // Change cursor based on disabled state
                        }}
                      ></textarea>
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {reportDescriptionError} </span>
                      </p>
                    </div>
                  </div>

                  <div className="inputMainContainer w40dot75rem mt30">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Dataset*</label>
                      <select
                        name="Dataset"
                        className="inputType ArrowSelectClass"
                        id="Dataset"
                        onChange={handleDatasetChange}
                        disabled={!isReportFormEnabled}
                        style={{
                          cursor: !isReportFormEnabled ? "not-allowed" : "pointer", // Change cursor based on disabled state
                        }}
                        value={currentDatasetId}
                         // Set the selected dataset ID1
                      >
                        <option key="0" disabled={false} value="0" id="0">
                          Select Dataset
                        </option>
                        {datasets.map((dataset, index) => (
                          <option
                            key={index}
                            value={dataset.ReportDataSetID}
                            id={dataset.ReportDataSetID}
                          >
                            {dataset.DataSetName}
                          </option>
                        ))}
                      </select>
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {selectedDatasetError} </span>
                      </p>
                    </div>
                  </div>

                  <div className="inputMainContainer w40dot75rem mt30 ReportMultiSelect">
                    <div className="inputTypeLabelContainer">
                      <label
                        className="formFieldLabels"
                        style={{ zIndex: "0" }}
                      >
                        Column*
                      </label>
                      <MultiSelect
                        options={multiSelectOptions} // Dynamically generated options
                        value={multiSelectOptions.filter((option) =>
                          selectedColumns.includes(option.value)
                        )} // Pre-select options based on selectedColumns
                        onChange={handleColumnChange} // Update selected columns
                        labelledBy="Select Columns"
                        overrideStrings={{
                          selectSomeItems: "Select Columns",
                          allItemsAreSelected: "All columns selected",
                        }}
                        disabled={!isReportFormEnabled}
                        ArrowRenderer={() => <DropArrow />}
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {selectedColumnsError} </span>
                      </p>
                    </div>
                  </div>

                  <div className="inputMainContainer w40dot75rem mt30 ReportMultiSelect">
                    <div className="inputTypeLabelContainer">
                      <label
                        className="formFieldLabels"
                        style={{ zIndex: "0" }}
                      >
                        User List
                      </label>
                      <MultiSelect
                        options={userListOptions} // Dynamically generated user list
                        value={userListOptions.filter((option) =>
                          selectedUsers.includes(option.value)
                        )} // Pre-select options based on selectedUsers
                        onChange={handleUserChange} // Update selected users
                        labelledBy="Select Users"
                        overrideStrings={{
                          selectSomeItems: "Select User",
                          allItemsAreSelected: "All users selected",
                        }}
                        disabled={!isReportFormEnabled}
                        style={{
                          cursor: !isReportFormEnabled ? "not-allowed" : "pointer", // Change cursor based on disabled state
                        }}
                        ArrowRenderer={() => <DropArrow />}
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {selectedUsersError} </span>
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
